// logoConfig.js
import logo from "../Assets/Images/logo.png";

const logoConfig = {
  src: logo,
  alt: "St John's",
};

export default logoConfig;

